import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
// Trigger deploy build
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import NagusiBackNav from '../common/NagusiBackNav';
import Lineup from '../lineup/Lineup';
import CalendarSubscribeModal from './CalendarSubscribeModal';
import CalendarMonthView from './CalendarMonthView';
import { formatShieldUrl } from '../../common/models/Rival';
const dayjs = window.dayjs;
export default class CalendarPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "seasons", []);
    _defineProperty(this, "selectedSeasonId", '');
    _defineProperty(this, "selectedSeasonName", '');
    _defineProperty(this, "selectedSeasonSlug", '');
    _defineProperty(this, "matches", []);
    _defineProperty(this, "players", []);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "loadingNextDetails", false);
    _defineProperty(this, "loadingLastRatings", false);
    _defineProperty(this, "lastMatchRatingsLoaded", false);
    _defineProperty(this, "expandedNextLineup", false);
    _defineProperty(this, "expandedLastRatings", false);
    _defineProperty(this, "expandedMatchIds", {});
    _defineProperty(this, "loadedMatchDetails", {});
    _defineProperty(this, "loadingMatchDetails", {});
    _defineProperty(this, "onHashChange", null);
    _defineProperty(this, "lastProcessedHash", '');
    _defineProperty(this, "viewMode", 'list');
    _defineProperty(this, "selectedCalendarMatchId", null);
  }
  renderNotesHtml(htmlOrText) {
    if (!htmlOrText || typeof htmlOrText !== 'string' || !htmlOrText.trim()) return null;
    let content = htmlOrText.trim();

    // 1. Process BBCode tags
    content = content.replace(/\[b\]([\s\S]*?)\[\/b\]/gi, '<strong>$1</strong>').replace(/\[i\]([\s\S]*?)\[\/i\]/gi, '<em>$1</em>').replace(/\[u\]([\s\S]*?)\[\/u\]/gi, '<u>$1</u>').replace(/\[s\]([\s\S]*?)\[\/s\]/gi, '<del>$1</del>').replace(/\[center\]([\s\S]*?)\[\/center\]/gi, '<div style="text-align:center;">$1</div>').replace(/\[quote\]([\s\S]*?)\[\/quote\]/gi, '<blockquote style="border-left: 3px solid rgba(255,255,255,0.2); padding-left: 10px; margin: 8px 0; color: var(--muted-color);">$1</blockquote>').replace(/\[url=(.*?)\]([\s\S]*?)\[\/url\]/gi, '<a href="$1" target="_blank" rel="noopener noreferrer" style="color: #60a5fa; text-decoration: underline;">$2</a>').replace(/\[url\]([\s\S]*?)\[\/url\]/gi, '<a href="$1" target="_blank" rel="noopener noreferrer" style="color: #60a5fa; text-decoration: underline;">$1</a>');

    // 2. Process basic Markdown tags
    content = content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\*(.*?)\*/g, '<em>$1</em>').replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" style="color: #60a5fa; text-decoration: underline;">$1</a>');

    // 3. If there are no block HTML tags, convert newlines to <br>
    if (!/<(p|div|br|h[1-6]|ul|ol|li|blockquote)\b[^>]*>/i.test(content)) {
      content = content.replace(/\r\n|\r|\n/g, '<br>');
    }
    return m.trust(content);
  }
  oninit(vnode) {
    super.oninit(vnode);
    const routeSeason = m.route.param('season');
    const defaultSeason = app.forum.attribute('nagusiMatchRatingsLatestSeason') || '2026-2027';
    const targetSlug = (routeSeason || defaultSeason).replace(/\//g, '-');
    this.selectedSeasonSlug = targetSlug;
    this.selectedSeasonName = targetSlug;
    const viewParam = m.route.param('view');
    if (viewParam === 'list' || viewParam === 'calendar') {
      this.viewMode = viewParam;
    } else {
      this.viewMode = 'list';
    }
    this.loadInitialData();
  }
  setViewMode(mode) {
    this.viewMode = mode;
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('flarum_calendar_view', mode);
    }
    m.redraw();
  }
  oncreate(vnode) {
    if (super.oncreate) {
      super.oncreate(vnode);
    }
    this.onHashChange = () => this.checkAndScrollToAnchor();
    window.addEventListener('hashchange', this.onHashChange);
    if (!this.loading) {
      this.checkAndScrollToAnchor();
    }
  }
  onupdate(vnode) {
    if (super.onupdate) {
      super.onupdate(vnode);
    }

    // Route change detection when component is kept mounted by Mithril router
    const routeSeason = m.route.param('season');
    if (routeSeason) {
      const currentSlug = routeSeason.replace(/\//g, '-');
      if (this.selectedSeasonSlug && this.selectedSeasonSlug !== currentSlug) {
        this.selectedSeasonSlug = currentSlug;
        const matchedSeason = this.seasons.find(s => s.name().replace(/\//g, '-') === currentSlug);
        if (matchedSeason) {
          this.selectedSeasonId = String(matchedSeason.id());
          this.selectedSeasonName = matchedSeason.name();
        } else {
          this.selectedSeasonName = currentSlug;
        }
        this.loadMatchesForSeason();
      }
    }
    if (!this.loading && window.location.hash && window.location.hash !== this.lastProcessedHash) {
      this.checkAndScrollToAnchor();
    }
  }
  onremove(vnode) {
    if (this.onHashChange) {
      window.removeEventListener('hashchange', this.onHashChange);
      this.onHashChange = null;
    }
    if (super.onremove) {
      super.onremove(vnode);
    }
  }
  checkAndScrollToAnchor() {
    const hash = window.location.hash || '';
    this.lastProcessedHash = hash;
    const match = hash.match(/^#(?:partido|match)-(\d+)$/i);
    if (!match) return;
    const targetMatchId = match[1];
    if (this.viewMode === 'calendar') {
      this.selectedCalendarMatchId = targetMatchId;
      m.redraw();
      setTimeout(() => {
        const inspector = document.getElementById("calendar-inspector-".concat(targetMatchId));
        if (inspector) {
          inspector.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }, 150);
    } else {
      // Asegurar que el partido está desplegado en la vista
      if (!this.expandedMatchIds[targetMatchId]) {
        this.expandedMatchIds[targetMatchId] = true;
        m.redraw();
      }
      setTimeout(() => {
        const el = document.getElementById("partido-".concat(targetMatchId));
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
          el.classList.add('CalendarPage-matchItem--highlight');
          setTimeout(() => {
            el.classList.remove('CalendarPage-matchItem--highlight');
          }, 3000);
        }
      }, 120);
    }
  }
  loadInitialData() {
    this.loading = true;
    this.expandedMatchIds = {};
    this.lastMatchRatingsLoaded = false;
    m.redraw();
    const seasonParam = this.selectedSeasonSlug || (this.selectedSeasonName ? this.selectedSeasonName.replace(/\//g, '-') : '');

    // Lanzar seasons, players y matches simultáneamente en paralelo
    const pSeasons = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/seasons'
    });
    const pPlayers = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/players?active=1'
    });
    const pMatches = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/matches',
      params: {
        season: seasonParam,
        include: 'rival,team,competition'
      }
    });
    Promise.all([pSeasons, pPlayers, pMatches]).then(_ref => {
      let _ref2 = _slicedToArray(_ref, 3),
        seasonsResponse = _ref2[0],
        playersResponse = _ref2[1],
        matchesResponse = _ref2[2];
      this.seasons = app.store.pushPayload(seasonsResponse) || [];
      this.players = app.store.pushPayload(playersResponse) || [];
      const loadedMatches = app.store.pushPayload(matchesResponse) || [];
      if (this.seasons.length > 0) {
        const sortedSeasons = [...this.seasons].sort((a, b) => b.name().localeCompare(a.name()));
        const targetSlug = this.selectedSeasonSlug || (this.selectedSeasonName ? this.selectedSeasonName.replace(/\//g, '-') : '');
        let matchedSeason = sortedSeasons.find(s => s.name().replace(/\//g, '-') === targetSlug || s.name() === this.selectedSeasonName);
        if (!matchedSeason) {
          matchedSeason = sortedSeasons[0];
        }
        this.selectedSeasonId = String(matchedSeason.id());
        this.selectedSeasonName = matchedSeason.name();
        this.selectedSeasonSlug = matchedSeason.name().replace(/\//g, '-');
      }
      this.matches = loadedMatches.sort((a, b) => {
        const dateA = typeof a.matchDate === 'function' && a.matchDate() ? new Date(a.matchDate()).getTime() : 0;
        const dateB = typeof b.matchDate === 'function' && b.matchDate() ? new Date(b.matchDate()).getTime() : 0;
        return dateA - dateB;
      });

      // La vista se desbloquea de inmediato: la página carga al instante (~80ms)
      this.loading = false;
      m.redraw();
      this.checkAndScrollToAnchor();

      // En segundo plano, cargar los pronósticos de La Bolilla y Alineación para nextMatch
      const _this$getFeaturedMatc = this.getFeaturedMatches(),
        nextMatch = _this$getFeaturedMatc.nextMatch;
      if (nextMatch) {
        this.loadingNextDetails = true;
        this.fetchMatchDetails(nextMatch.id()).finally(() => {
          this.loadingNextDetails = false;
          m.redraw();
        });
      }
    }).catch(err => {
      console.error('Error loading calendar data:', err);
      this.loading = false;
      m.redraw();
    });
  }
  getFeaturedMatches() {
    const now = new Date();
    const FOUR_HOURS_MS = 4 * 3600 * 1000;

    // Upcoming / current match: matchDate + 4h is in the future (match hasn't ended yet)
    const upcomingMatches = this.matches.filter(m => {
      const mDateVal = typeof m.matchDate === 'function' ? m.matchDate() : null;
      if (!mDateVal) return false;
      const mDate = new Date(mDateVal);
      return mDate.getTime() + FOUR_HOURS_MS > now.getTime();
    }).sort((a, b) => {
      const dateA = typeof a.matchDate === 'function' && a.matchDate() ? new Date(a.matchDate()).getTime() : 0;
      const dateB = typeof b.matchDate === 'function' && b.matchDate() ? new Date(b.matchDate()).getTime() : 0;
      return dateA - dateB; // earliest first
    });
    const nextMatch = upcomingMatches.length > 0 ? upcomingMatches[0] : null;

    // Disputed / finished matches: matchDate + 4h is in the past
    const playedMatches = this.matches.filter(m => {
      const mDateVal = typeof m.matchDate === 'function' ? m.matchDate() : null;
      if (!mDateVal) return false;
      const mDate = new Date(mDateVal);
      return mDate.getTime() + FOUR_HOURS_MS <= now.getTime();
    }).sort((a, b) => {
      const dateA = typeof a.matchDate === 'function' && a.matchDate() ? new Date(a.matchDate()).getTime() : 0;
      const dateB = typeof b.matchDate === 'function' && b.matchDate() ? new Date(b.matchDate()).getTime() : 0;
      return dateB - dateA; // most recent first
    });
    const lastMatch = playedMatches.length > 0 ? playedMatches[0] : null;
    return {
      nextMatch,
      lastMatch
    };
  }
  fetchMatchDetails(matchId) {
    const idStr = String(matchId);
    if (this.loadedMatchDetails[idStr]) {
      return Promise.resolve(this.matches.find(m => String(m.id()) === idStr));
    }
    if (this.loadingMatchDetails[idStr]) {
      return this.loadingMatchDetails[idStr];
    }
    const promise = app.request({
      method: 'GET',
      url: "".concat(app.forum.attribute('apiUrl'), "/nagusi/match-ratings/matches/").concat(idStr)
    }).then(response => {
      const loadedMatch = app.store.pushPayload(response);
      this.loadedMatchDetails[idStr] = true;
      delete this.loadingMatchDetails[idStr];
      const idx = this.matches.findIndex(m => String(m.id()) === idStr);
      if (idx !== -1 && loadedMatch) {
        this.matches[idx] = loadedMatch;
      }
      m.redraw();
      return loadedMatch;
    }).catch(err => {
      console.error("Error loading match details for ".concat(idStr, ":"), err);
      delete this.loadingMatchDetails[idStr];
      m.redraw();
    });
    this.loadingMatchDetails[idStr] = promise;
    return promise;
  }

  // Despliegue 100% instantáneo (0 ms) sin llamadas de red: los datos ya están en el modelo
  toggleMatchExpand(matchItem) {
    const mId = String(matchItem.id());
    this.expandedMatchIds[mId] = !this.expandedMatchIds[mId];
    m.redraw();
  }

  // Carga bajo demanda de valoraciones del último partido solo si el usuario pulsa "Ver valoraciones"
  toggleLastRatings(lastMatch) {
    this.expandedLastRatings = !this.expandedLastRatings;
    if (this.expandedLastRatings && !this.lastMatchRatingsLoaded && lastMatch) {
      this.loadingLastRatings = true;
      this.fetchMatchDetails(lastMatch.id()).then(() => {
        this.lastMatchRatingsLoaded = true;
      }).finally(() => {
        this.loadingLastRatings = false;
        m.redraw();
      });
    }
  }
  getMatchOutcome(match) {
    if (!match) return null;
    if (typeof match.getOutcome === 'function') {
      return match.getOutcome();
    }
    const scoreA = typeof match.scoreAthletic === 'function' ? match.scoreAthletic() : match.scoreAthletic;
    const scoreO = typeof match.scoreOpponent === 'function' ? match.scoreOpponent() : match.scoreOpponent;
    if (scoreA === null || scoreA === undefined || scoreO === null || scoreO === undefined) return null;
    const numA = Number(scoreA);
    const numO = Number(scoreO);
    if (isNaN(numA) || isNaN(numO)) return null;
    if (numA > numO) return 'win';
    if (numA < numO) return 'loss';
    const isKnockout = typeof match.isKnockout === 'function' ? match.isKnockout() : match.isKnockout;
    const knockoutWinner = typeof match.knockoutWinner === 'function' ? match.knockoutWinner() : match.knockoutWinner;
    if (isKnockout && knockoutWinner) {
      return knockoutWinner === 'Athletic' ? 'win' : 'loss';
    }
    return 'draw';
  }
  getScoreBadgeStyle(match) {
    if (match && typeof match.getOutcomeBadgeStyle === 'function') {
      return match.getOutcomeBadgeStyle();
    }
    const outcome = this.getMatchOutcome(match);
    if (outcome === 'win') {
      return {
        background: 'rgba(16, 185, 129, 0.15)',
        color: '#10b981',
        border: '1px solid rgba(16, 185, 129, 0.35)'
      };
    }
    if (outcome === 'loss') {
      return {
        background: 'rgba(238, 37, 35, 0.15)',
        color: '#ee2524',
        border: '1px solid rgba(238, 37, 35, 0.35)'
      };
    }
    if (outcome === 'draw') {
      return {
        background: 'rgba(148, 163, 184, 0.15)',
        color: '#94a3b8',
        border: '1px solid rgba(148, 163, 184, 0.3)'
      };
    }
    return {
      background: 'rgba(255, 255, 255, 0.08)',
      color: 'inherit',
      border: '1px solid rgba(255, 255, 255, 0.1)'
    };
  }
  isPlaceholderTime(dateVal) {
    const rawDate = typeof dateVal === 'function' ? dateVal() : dateVal;
    if (!rawDate) return false;
    const d = dayjs(rawDate);
    if (!d.isValid()) return false;
    const h = d.hour();
    // 1:00 or 2:00 in Spain (CEST/CET offset from 00:00 UTC) indicates kick-off time is not yet determined
    return h === 1 || h === 2 || h === 0 && d.minute() === 0;
  }
  formatMatchDate(dateVal, style) {
    if (style === void 0) {
      style = 'short';
    }
    const rawDate = typeof dateVal === 'function' ? dateVal() : dateVal;
    if (!rawDate) return '';
    const d = dayjs(rawDate);
    if (!d.isValid()) return '';
    const isPlaceholder = this.isPlaceholderTime(rawDate);
    if (style === 'long') {
      return isPlaceholder ? d.format('D MMMM YYYY') : "".concat(d.format('D MMMM YYYY, HH:mm'), " h");
    }
    return isPlaceholder ? d.format('DD/MM/YYYY') : d.format('DD/MM/YYYY HH:mm');
  }
  loadMatchesForSeason() {
    this.loading = true;
    this.expandedMatchIds = {};
    this.lastMatchRatingsLoaded = false;
    m.redraw();
    const seasonParam = this.selectedSeasonSlug || (this.selectedSeasonName ? this.selectedSeasonName.replace(/\//g, '-') : '');
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/matches',
      params: {
        season: seasonParam,
        include: 'rival,team,competition'
      }
    }).then(response => {
      const loadedMatches = app.store.pushPayload(response) || [];
      this.matches = loadedMatches.sort((a, b) => {
        const dateA = typeof a.matchDate === 'function' && a.matchDate() ? new Date(a.matchDate()).getTime() : 0;
        const dateB = typeof b.matchDate === 'function' && b.matchDate() ? new Date(b.matchDate()).getTime() : 0;
        return dateA - dateB;
      });
      this.loading = false;
      m.redraw();
      const _this$getFeaturedMatc2 = this.getFeaturedMatches(),
        nextMatch = _this$getFeaturedMatc2.nextMatch;
      if (nextMatch) {
        this.loadingNextDetails = true;
        this.fetchMatchDetails(nextMatch.id()).finally(() => {
          this.loadingNextDetails = false;
          m.redraw();
        });
      }
    }).catch(err => {
      console.error('Error loading matches for season:', err);
      this.loading = false;
      m.redraw();
    });
  }
  onSeasonChange(e) {
    const target = e.target;
    const val = target.value;
    const found = this.seasons.find(s => s.name().replace(/\//g, '-') === val || String(s.id()) === String(val));
    if (found) {
      this.selectedSeasonId = String(found.id());
      this.selectedSeasonName = found.name();
      const seasonSlug = found.name().replace(/\//g, '-');
      this.selectedSeasonSlug = seasonSlug;
      m.route.set("/calendario/".concat(seasonSlug, "/athletic-club"));
      this.loadMatchesForSeason();
    }
  }
  getMostVotedBolilla(match) {
    const votes = match.bolillaVotes() || [];
    if (!votes.length) return null;
    const counts = {};
    votes.forEach(v => {
      const score = v.votedScore ? v.votedScore() : null;
      if (score) {
        counts[score] = (counts[score] || 0) + 1;
      }
    });
    let topScore = null;
    let maxVotes = 0;
    Object.keys(counts).forEach(scoreKey => {
      if (counts[scoreKey] > maxVotes) {
        maxVotes = counts[scoreKey];
        topScore = scoreKey;
      }
    });
    return topScore ? {
      score: topScore,
      totalVotes: votes.length,
      scoreVotes: maxVotes
    } : null;
  }
  getConsensusLineup(match) {
    const userLineups = match.userMatchLineups() || [];
    if (!userLineups.length) return null;

    // Group identical 11-player lineups by sorted player names
    const groups = {};
    userLineups.forEach(l => {
      const playersRaw = typeof l.playersRaw === 'function' ? l.playersRaw() : l.playersRaw;
      if (typeof playersRaw === 'string' && playersRaw.length > 0) {
        const players = playersRaw.split(',').map(p => {
          const parts = p.split(':');
          if (parts.length >= 3 && !isNaN(Number(parts[1]))) {
            return parts.slice(2).join(':').trim().toLowerCase();
          }
          return parts.length >= 2 ? parts.slice(1).join(':').trim().toLowerCase() : p.trim().toLowerCase();
        }).filter(name => name && name !== '?');
        if (players.length === 11) {
          const key = players.slice().sort().join(',');
          if (!groups[key]) {
            groups[key] = {
              count: 0,
              lineup: l
            };
          }
          groups[key].count++;
        }
      }
    });
    const sortedGroups = Object.values(groups).sort((a, b) => b.count - a.count);
    if (sortedGroups.length > 0) {
      const topGroup = sortedGroups[0];
      const topLineup = topGroup.lineup;
      const formation = (typeof topLineup.formation === 'function' ? topLineup.formation() : topLineup.formation) || '4-2-3-1';
      const playersString = typeof topLineup.playersRaw === 'function' ? topLineup.playersRaw() : topLineup.playersRaw;
      return {
        formation,
        totalLineups: userLineups.length,
        scoreVotes: topGroup.count,
        playersString
      };
    }

    // Fallback if no exact 11-player complete lineup found: use first available lineup
    const firstLineup = userLineups[0];
    const formation = (typeof firstLineup.formation === 'function' ? firstLineup.formation() : firstLineup.formation) || '4-2-3-1';
    const playersString = typeof firstLineup.playersRaw === 'function' ? firstLineup.playersRaw() : firstLineup.playersRaw;
    return {
      formation,
      totalLineups: userLineups.length,
      scoreVotes: 1,
      playersString
    };
  }
  getCommunityRatings(match) {
    const votes = match.votes() || [];
    if (!votes.length) return [];
    const playerRatings = {};
    votes.forEach(v => {
      const player = typeof v.player === 'function' ? v.player() : v.player;
      const rating = typeof v.rating === 'function' ? v.rating() : v.rating;
      if (player && rating !== null && rating !== undefined) {
        const id = typeof player.id === 'function' ? player.id() : player.id || Math.random();
        const name = typeof player.shortName === 'function' && player.shortName() ? player.shortName() : typeof player.name === 'function' ? player.name() : player.name || player.shortName || 'Jugador';
        if (!playerRatings[id]) {
          playerRatings[id] = {
            name,
            sum: 0,
            count: 0
          };
        }
        playerRatings[id].sum += parseFloat(rating);
        playerRatings[id].count++;
      }
    });
    return Object.keys(playerRatings).map(id => ({
      id,
      name: playerRatings[id].name,
      average: (playerRatings[id].sum / playerRatings[id].count).toFixed(2),
      count: playerRatings[id].count
    })).sort((a, b) => parseFloat(b.average) - parseFloat(a.average));
  }
  view() {
    const athleticName = app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Athletic Club';
    const sortedSeasons = [...this.seasons].sort((a, b) => b.name().localeCompare(a.name()));
    if (this.loading) {
      return m("div", {
        className: "CalendarPage"
      }, m("div", {
        className: "container",
        style: "padding: 60px 20px; text-align: center;"
      }, m(LoadingIndicator, null)));
    }

    // Categorize matches into Next Match, Last Match, and Rest of Season
    const _this$getFeaturedMatc3 = this.getFeaturedMatches(),
      nextMatch = _this$getFeaturedMatc3.nextMatch,
      lastMatch = _this$getFeaturedMatc3.lastMatch;
    const restOfMatches = this.matches;
    const nextBolilla = nextMatch ? this.getMostVotedBolilla(nextMatch) : null;
    const nextLineup = nextMatch ? this.getConsensusLineup(nextMatch) : null;
    const lastRatings = lastMatch ? this.getCommunityRatings(lastMatch) : [];
    const lastOutcome = lastMatch ? this.getMatchOutcome(lastMatch) : null;
    const lastBadgeStyle = lastMatch ? this.getScoreBadgeStyle(lastMatch) : null;
    const lastAccentColor = lastOutcome === 'win' ? '#10b981' : lastOutcome === 'loss' ? '#ee2524' : '#64748b';

    // Check if current logged in user has predictions for nextMatch
    const currentUserId = app.session.user ? app.session.user.id() : null;
    const userBolillaVote = nextMatch && currentUserId && (nextMatch.bolillaVotes() || []).find(v => {
      const voteUserId = v.user() ? v.user().id() : typeof v.userId === 'function' ? v.userId() : v.userId;
      return String(voteUserId) === String(currentUserId);
    }) || null;
    const userHasBolilla = !!userBolillaVote;
    const userBolillaScore = userBolillaVote ? typeof userBolillaVote.votedScore === 'function' ? userBolillaVote.votedScore() : userBolillaVote.votedScore : null;
    const userLineupObj = nextMatch && currentUserId && (nextMatch.userMatchLineups() || []).find(l => String(l.userId()) === String(currentUserId)) || null;
    const userHasLineup = !!userLineupObj;
    const userLineupData = userLineupObj ? {
      formation: (typeof userLineupObj.formation === 'function' ? userLineupObj.formation() : userLineupObj.formation) || '4-2-3-1',
      playersString: typeof userLineupObj.playersRaw === 'function' ? userLineupObj.playersRaw() : userLineupObj.playersRaw
    } : null;
    const seasonSlug = this.selectedSeasonSlug || (this.selectedSeasonName ? this.selectedSeasonName.replace(/\//g, '-') : '');
    return m("div", {
      className: "CalendarPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 30px; padding-bottom: 50px;"
    }, m(NagusiBackNav, {
      title: app.translator.trans('nagusi-match-ratings.forum.calendar.title')
    }), m("div", {
      className: "CalendarPage-header",
      style: "display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 20px; margin-bottom: 22px; border-bottom: 2px solid rgba(255,255,255,0.08); padding-bottom: 20px;"
    }, m("div", null, m("h1", {
      style: "font-size: 2.4em; font-weight: 900; margin: 0; color: var(--heading-color); letter-spacing: -0.02em;"
    }, m("i", {
      className: "far fa-calendar-alt",
      style: "margin-right: 12px; color: #ee2523;"
    }), app.translator.trans('nagusi-match-ratings.forum.calendar.title')), m("p", {
      style: "margin: 6px 0 0 0; color: var(--muted-color); font-size: 1.1em;"
    }, athleticName, " \u2014 ", app.translator.trans('nagusi-match-ratings.forum.calendar.season_label'), " ", this.selectedSeasonName)), m("div", {
      style: "display: flex; align-items: center; gap: 12px; flex-wrap: wrap;"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 10px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.95em;"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.season_label')), m("select", {
      className: "FormControl",
      value: this.selectedSeasonSlug,
      onchange: this.onSeasonChange.bind(this),
      style: "border-radius: 10px; padding: 8px 16px; font-weight: bold; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.15); height: 42px; cursor: pointer;"
    }, sortedSeasons.map(s => {
      const slug = s.name().replace(/\//g, '-');
      return m("option", {
        value: slug
      }, s.name());
    }))), seasonSlug >= '2025-2026' && m("a", {
      href: "/clasificacion/".concat(seasonSlug, "/athletic-club"),
      className: "Button Button--secondary",
      style: "border-radius: 10px; padding: 8px 16px; font-weight: bold; display: inline-flex; align-items: center; gap: 8px; text-decoration: none; height: 42px; border: 1px solid rgba(255,255,255,0.2);"
    }, m("i", {
      className: "fas fa-list-ol",
      style: "color: #ee2524;"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.view_standings_button', {}, 'Ver Clasificación'))), m(Button, {
      className: "Button Button--primary",
      icon: "far fa-calendar-plus",
      onclick: () => app.modal.show(CalendarSubscribeModal, {
        seasonSlug
      }),
      style: "border-radius: 10px; padding: 8px 16px; font-weight: bold; display: inline-flex; align-items: center; gap: 8px; height: 42px; background: #ee2524; border: 1px solid #ee2524; color: #fff; cursor: pointer;"
    }, m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.sync_button', {}, 'Sincronizar Calendario'))))), m("div", {
      className: "CalendarPage-toolbar"
    }, m("div", {
      className: "CalendarPage-viewToggle",
      role: "tablist",
      "aria-label": "Modo de visualizaci\xF3n"
    }, m("button", {
      type: "button",
      role: "tab",
      "aria-selected": this.viewMode === 'list',
      className: "CalendarPage-toggleBtn ".concat(this.viewMode === 'list' ? 'is-active' : ''),
      onclick: () => this.setViewMode('list')
    }, m("i", {
      className: "fas fa-th-list"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.view_list', {}, 'Lista'))), m("button", {
      type: "button",
      role: "tab",
      "aria-selected": this.viewMode === 'calendar',
      className: "CalendarPage-toggleBtn ".concat(this.viewMode === 'calendar' ? 'is-active' : ''),
      onclick: () => this.setViewMode('calendar')
    }, m("i", {
      className: "far fa-calendar-alt"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.view_calendar', {}, 'Calendario')))), m("div", {
      className: "CalendarPage-matchesMeta"
    }, m("span", {
      className: "meta-chip"
    }, m("i", {
      className: "fas fa-futbol",
      style: "margin-right: 6px; color: #ee2524;"
    }), m("strong", null, this.matches.length), " partidos"), m("span", {
      className: "meta-desc"
    }, this.viewMode === 'list' ? 'Vista cronológica' : 'Vista mensual interactiva'))), nextMatch && this.viewMode === 'list' && m("div", {
      className: "CalendarPage-featuredCard CalendarPage-nextMatch",
      style: "background: var(--control-bg); border: 1px solid rgba(238,37,35,0.4); border-left: 6px solid #ee2523; border-radius: 12px; padding: 24px; margin-bottom: 30px; box-shadow: 0 4px 15px rgba(0,0,0,0.05); position: relative;"
    }, m("div", {
      style: "position: absolute; top: 12px; right: 16px; background: #ee2523; color: #fff; font-size: 0.75em; font-weight: 900; text-transform: uppercase; padding: 4px 12px; border-radius: 20px; letter-spacing: 0.05em;"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.next_match_badge')), m("div", {
      style: "display: flex; flex-direction: column; gap: 16px;"
    }, m("div", {
      style: "display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 15px; margin-top: 10px;"
    }, m("h2", {
      style: "font-size: 1.6em; font-weight: 800; margin: 0; color: var(--heading-color);"
    }, typeof nextMatch.renderName === 'function' ? nextMatch.renderName({
      showJornada: true
    }) : typeof nextMatch.getName === 'function' ? nextMatch.getName() : app.translator.trans('nagusi-match-ratings.forum.calendar.next_match_badge')), nextMatch.matchDate() && m("div", {
      style: "font-size: 1em; font-weight: 700; background: rgba(238,37,35,0.08); color: var(--heading-color); padding: 6px 14px; border-radius: 8px; border: 1px solid rgba(238,37,35,0.2);"
    }, m("i", {
      className: this.isPlaceholderTime(nextMatch.matchDate()) ? "far fa-calendar-alt" : "far fa-clock",
      style: "margin-right: 8px; color: #ee2524;"
    }), this.formatMatchDate(nextMatch.matchDate(), 'long'))), (typeof nextMatch.tvChannel === 'function' && nextMatch.tvChannel() || typeof nextMatch.referee === 'function' && nextMatch.referee() || typeof nextMatch.varReferee === 'function' && nextMatch.varReferee() || typeof nextMatch.pressConferenceUrl === 'function' && nextMatch.pressConferenceUrl() || typeof nextMatch.callupUrl === 'function' && nextMatch.callupUrl() || typeof nextMatch.previewUrl === 'function' && nextMatch.previewUrl()) && m("div", {
      style: "display: flex; flex-direction: column; gap: 8px; background: rgba(0,0,0,0.03); padding: 12px 16px; border-radius: 10px; border: 1px solid rgba(0,0,0,0.06);"
    }, m("div", {
      style: "font-size: 0.75em; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--muted-color);"
    }, "\uD83D\uDCCC Informaci\xF3n Previa"), m("div", {
      style: "display: flex; flex-wrap: wrap; gap: 10px; align-items: center;"
    }, typeof nextMatch.tvChannel === 'function' && nextMatch.tvChannel() && m("div", {
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; background: rgba(96,165,250,0.15); color: #3b82f6; padding: 6px 14px; border-radius: 8px;"
    }, m("i", {
      className: "fas fa-tv"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.tv_label', {
      channel: nextMatch.tvChannel()
    }))), typeof nextMatch.referee === 'function' && nextMatch.referee() && m("div", {
      style: "font-size: 0.9em; font-weight: 600; background: rgba(255,255,255,0.03); padding: 6px 12px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.06);"
    }, m("i", {
      className: "fas fa-balance-scale",
      style: "margin-right: 6px; color: #f59e0b;"
    }), m("span", null, "\xC1rbitro: ", m("strong", {
      style: "color: var(--heading-color);"
    }, nextMatch.referee()))), typeof nextMatch.varReferee === 'function' && nextMatch.varReferee() && m("div", {
      style: "font-size: 0.9em; font-weight: 600; background: rgba(255,255,255,0.03); padding: 6px 12px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.06);"
    }, m("i", {
      className: "fas fa-desktop",
      style: "margin-right: 6px; color: #3b82f6;"
    }), m("span", null, "VAR: ", m("strong", {
      style: "color: var(--heading-color);"
    }, nextMatch.varReferee()))), typeof nextMatch.pressConferenceUrl === 'function' && nextMatch.pressConferenceUrl() && m("a", {
      href: nextMatch.pressConferenceUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 6px 14px; text-decoration: none;"
    }, m("i", {
      className: "fas fa-video",
      style: "color: #ec4899;"
    }), m("span", null, "Rueda de Prensa Previa")), typeof nextMatch.callupUrl === 'function' && nextMatch.callupUrl() && m("a", {
      href: nextMatch.callupUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 6px 14px; text-decoration: none;"
    }, m("i", {
      className: "fas fa-list-ol",
      style: "color: #10b981;"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.callup_button'))), typeof nextMatch.previewUrl === 'function' && nextMatch.previewUrl() && m("a", {
      href: nextMatch.previewUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 6px 14px; text-decoration: none;"
    }, m("i", {
      className: "fas fa-newspaper",
      style: "color: #f59e0b;"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.preview_button'))))), (typeof nextMatch.postPressConferenceUrl === 'function' && nextMatch.postPressConferenceUrl() || typeof nextMatch.highlightsUrl === 'function' && nextMatch.highlightsUrl() || typeof nextMatch.fullMatchUrl === 'function' && nextMatch.fullMatchUrl()) && m("div", {
      style: "display: flex; flex-direction: column; gap: 8px; background: rgba(0,0,0,0.03); padding: 12px 16px; border-radius: 10px; border: 1px solid rgba(0,0,0,0.06);"
    }, m("div", {
      style: "font-size: 0.75em; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--muted-color);"
    }, "\uD83C\uDFAC Informaci\xF3n Posterior"), m("div", {
      style: "display: flex; flex-wrap: wrap; gap: 10px;"
    }, typeof nextMatch.postPressConferenceUrl === 'function' && nextMatch.postPressConferenceUrl() && m("a", {
      href: nextMatch.postPressConferenceUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 6px 14px; text-decoration: none;"
    }, m("i", {
      className: "fas fa-microphone",
      style: "color: #a855f7;"
    }), m("span", null, "Rueda de Prensa Posterior")), typeof nextMatch.highlightsUrl === 'function' && nextMatch.highlightsUrl() && m("a", {
      href: nextMatch.highlightsUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 6px 14px; text-decoration: none;"
    }, m("i", {
      className: "fas fa-play-circle",
      style: "color: #ef4444;"
    }), m("span", null, "Resumen del Partido")), typeof nextMatch.fullMatchUrl === 'function' && nextMatch.fullMatchUrl() && m("a", {
      href: nextMatch.fullMatchUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 6px 14px; text-decoration: none;"
    }, m("i", {
      className: "fas fa-film",
      style: "color: #3b82f6;"
    }), m("span", null, "Partido Completo")))), typeof nextMatch.notesHtml === 'function' && nextMatch.notesHtml() && m("div", {
      style: "background: rgba(255,255,255,0.02); border-radius: 10px; padding: 16px 20px; border: 1px solid rgba(255,255,255,0.06); display: flex; flex-direction: column; gap: 10px;"
    }, m("div", {
      style: "font-size: 0.85em; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--muted-color);"
    }, "\uD83D\uDCDD ", app.translator.trans('nagusi-match-ratings.forum.calendar.notes_label')), m("div", {
      style: "font-size: 0.95em; line-height: 1.6; color: var(--text-color);"
    }, this.renderNotesHtml(nextMatch.notesHtml()))), m("div", {
      style: "background: rgba(238,37,35,0.04); padding: 16px 20px; border-radius: 10px; border: 1px dashed rgba(238,37,35,0.3); display: flex; flex-direction: column; gap: 12px;"
    }, m("div", {
      style: "display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;"
    }, m("div", null, m("div", {
      style: "font-size: 0.8em; text-transform: uppercase; font-weight: 800; letter-spacing: 0.05em; color: #ee2523; margin-bottom: 4px;"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.bolilla_forecast_title')), m("div", {
      style: "font-size: 1.25em; font-weight: 800; color: var(--heading-color);"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.most_voted_result'), ' ', m("span", {
      style: "color: #ee2523; font-family: monospace; background: rgba(238,37,35,0.1); padding: 2px 10px; border-radius: 6px;"
    }, this.loadingNextDetails ? m("span", {
      style: "display: inline-flex; align-items: center; gap: 6px; font-size: 0.85em; font-family: sans-serif;"
    }, m("i", {
      className: "fas fa-spinner fa-spin"
    })) : nextBolilla ? nextBolilla.score : app.translator.trans('nagusi-match-ratings.forum.calendar.no_forecasts_yet')))), !this.loadingNextDetails && nextBolilla && m("div", {
      style: "font-size: 0.85em; color: var(--muted-color); font-weight: 600;"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.foreros_agree', {
      scoreVotes: nextBolilla.scoreVotes,
      totalVotes: nextBolilla.totalVotes
    }))), userHasBolilla && userBolillaScore && m("div", {
      style: "font-size: 1em; font-weight: 700; color: var(--heading-color); background: rgba(16,185,129,0.08); border: 1px solid rgba(16,185,129,0.25); padding: 8px 14px; border-radius: 8px; display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: "fas fa-bullseye",
      style: "color: #10b981;"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.your_bolilla_forecast'), " ", m("strong", {
      style: "color: #10b981; font-family: monospace; font-size: 1.1em; background: rgba(16,185,129,0.15); padding: 2px 8px; border-radius: 4px;"
    }, userBolillaScore))), m("div", {
      style: "display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; border-top: 1px dashed rgba(238,37,35,0.2); padding-top: 10px; margin-top: 2px;"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 8px;"
    }, app.session.user ? userHasBolilla ? m("span", {
      style: "font-size: 0.85em; font-weight: 700; color: #10b981; background: rgba(16,185,129,0.12); padding: 4px 10px; border-radius: 6px; border: 1px solid rgba(16,185,129,0.3); display: inline-flex; align-items: center; gap: 6px;"
    }, m("i", {
      className: "fas fa-check-circle"
    }), " ", app.translator.trans('nagusi-match-ratings.forum.calendar.bolilla_completed')) : m("span", {
      style: "font-size: 0.85em; font-weight: 700; color: #f59e0b; background: rgba(245,158,11,0.12); padding: 4px 10px; border-radius: 6px; border: 1px solid rgba(245,158,11,0.3); display: inline-flex; align-items: center; gap: 6px;"
    }, m("i", {
      className: "fas fa-exclamation-triangle"
    }), " ", app.translator.trans('nagusi-match-ratings.forum.calendar.bolilla_pending')) : null), m("a", {
      href: "/la-bolilla/".concat(seasonSlug, "/votar"),
      className: "Button Button--primary",
      style: "font-weight: bold; border-radius: 8px; font-size: 0.9em; text-decoration: none; display: inline-flex; align-items: center; gap: 6px;"
    }, m("i", {
      className: "fas fa-futbol"
    }), m("span", null, userHasBolilla ? app.translator.trans('nagusi-match-ratings.forum.calendar.modify_bolilla') : app.translator.trans('nagusi-match-ratings.forum.calendar.fill_bolilla'))))), m("div", {
      style: "border-top: 1px solid rgba(0,0,0,0.06); padding-top: 12px;"
    }, m("div", {
      style: "display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 10px; flex-wrap: wrap;"
    }, m(Button, {
      className: "Button Button--secondary",
      onclick: () => this.expandedNextLineup = !this.expandedNextLineup,
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 8px 16px;"
    }, m("i", {
      className: "fas fa-chevron-".concat(this.expandedNextLineup ? 'up' : 'down')
    }), m("span", null, this.expandedNextLineup ? app.translator.trans('nagusi-match-ratings.forum.calendar.hide_lineup_button') : app.translator.trans('nagusi-match-ratings.forum.calendar.show_lineup_button'))), app.session.user && (userHasLineup ? m("span", {
      style: "font-size: 0.85em; font-weight: 700; color: #10b981; background: rgba(16,185,129,0.12); padding: 4px 10px; border-radius: 6px; border: 1px solid rgba(16,185,129,0.3); display: inline-flex; align-items: center; gap: 6px;"
    }, m("i", {
      className: "fas fa-check-circle"
    }), " ", app.translator.trans('nagusi-match-ratings.forum.calendar.lineup_created')) : m("span", {
      style: "font-size: 0.85em; font-weight: 700; color: #f59e0b; background: rgba(245,158,11,0.12); padding: 4px 10px; border-radius: 6px; border: 1px solid rgba(245,158,11,0.3); display: inline-flex; align-items: center; gap: 6px;"
    }, m("i", {
      className: "fas fa-exclamation-triangle"
    }), " ", app.translator.trans('nagusi-match-ratings.forum.calendar.lineup_pending')))), m("a", {
      href: "/11-aldeanos/".concat(seasonSlug, "/pronosticar"),
      className: "Button Button--primary",
      style: "font-weight: bold; border-radius: 8px; font-size: 0.9em; text-decoration: none; display: inline-flex; align-items: center; gap: 6px;"
    }, m("i", {
      className: "fas fa-tshirt"
    }), m("span", null, userHasLineup ? app.translator.trans('nagusi-match-ratings.forum.calendar.modify_lineup') : app.translator.trans('nagusi-match-ratings.forum.calendar.create_lineup')))), this.expandedNextLineup && m("div", {
      style: "margin-top: 16px; background: rgba(0,0,0,0.02); border-radius: 10px; padding: 18px; border: 1px solid rgba(0,0,0,0.08); display: flex; flex-direction: column; align-items: center; gap: 20px;"
    }, nextLineup ? m("div", {
      style: "width: 100%; display: flex; flex-direction: column; align-items: center; gap: 12px;"
    }, m("p", {
      style: "margin: 0; font-weight: 700; color: var(--heading-color); text-align: center;"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.most_voted_formation'), " ", m("span", {
      style: "color: #ee2523; font-weight: 800;"
    }, nextLineup.formation), " (", nextLineup.scoreVotes, " ", nextLineup.scoreVotes === 1 ? 'forero ha' : 'foreros han', " votado esta alineaci\xF3n de ", nextLineup.totalLineups, " ", nextLineup.totalLineups === 1 ? 'participante' : 'participantes', ")"), m("div", {
      style: "width: 100%; max-width: 480px; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.15);"
    }, m(Lineup, {
      formation: nextLineup.formation,
      kit: "athletic",
      players: nextLineup.playersString
    }))) : m("p", {
      style: "margin: 0; color: var(--muted-color);"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.no_lineups_yet')), userHasLineup && userLineupData && m("div", {
      style: "width: 100%; display: flex; flex-direction: column; align-items: center; gap: 12px; border-top: 1px dashed rgba(255,255,255,0.15); padding-top: 20px;"
    }, m("p", {
      style: "margin: 0; font-weight: 800; color: #10b981; text-align: center; font-size: 1.05em; display: flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-tshirt"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.your_configured_lineup', {
      formation: userLineupData.formation
    }))), m("div", {
      style: "width: 100%; max-width: 480px; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border: 2px solid rgba(16,185,129,0.4);"
    }, m(Lineup, {
      formation: userLineupData.formation,
      kit: "athletic",
      players: userLineupData.playersString
    }))), m("a", {
      href: "/11-aldeanos/".concat(seasonSlug, "/pronosticar"),
      className: "Button Button--primary",
      style: "font-weight: bold; border-radius: 8px; margin-top: 6px; text-decoration: none; display: inline-flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-tshirt"
    }), m("span", null, userHasLineup ? app.translator.trans('nagusi-match-ratings.forum.calendar.modify_lineup') : app.translator.trans('nagusi-match-ratings.forum.calendar.create_lineup'))))))), lastMatch && this.viewMode === 'list' && m("div", {
      className: "CalendarPage-featuredCard CalendarPage-lastMatch",
      style: {
        background: 'var(--control-bg)',
        border: '1px solid rgba(0,0,0,0.1)',
        borderLeft: "6px solid ".concat(lastAccentColor),
        borderRadius: '12px',
        padding: '24px',
        marginBottom: '30px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
        position: 'relative'
      }
    }, m("div", {
      style: {
        position: 'absolute',
        top: '12px',
        right: '16px',
        background: lastAccentColor,
        color: '#fff',
        fontSize: '0.75em',
        fontWeight: 800,
        textTransform: 'uppercase',
        padding: '4px 12px',
        borderRadius: '20px',
        letterSpacing: '0.05em'
      }
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.last_match_badge')), m("div", {
      style: "display: flex; flex-direction: column; gap: 16px;"
    }, m("div", {
      style: "display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 15px; margin-top: 10px;"
    }, m("h2", {
      style: "font-size: 1.5em; font-weight: 800; margin: 0; color: var(--heading-color);"
    }, typeof lastMatch.renderName === 'function' ? lastMatch.renderName({
      showJornada: true,
      showScore: false
    }) : typeof lastMatch.getName === 'function' ? lastMatch.getName() : app.translator.trans('nagusi-match-ratings.forum.calendar.last_match_badge')), m("div", {
      style: _objectSpread({
        fontSize: '1.4em',
        fontWeight: 900,
        padding: '4px 16px',
        borderRadius: '8px',
        fontFamily: 'monospace'
      }, lastBadgeStyle)
    }, typeof lastMatch.getScore === 'function' && lastMatch.getScore() || app.translator.trans('nagusi-match-ratings.forum.calendar.finished_status'))), (typeof lastMatch.tvChannel === 'function' && lastMatch.tvChannel() || typeof lastMatch.referee === 'function' && lastMatch.referee() || typeof lastMatch.varReferee === 'function' && lastMatch.varReferee() || typeof lastMatch.pressConferenceUrl === 'function' && lastMatch.pressConferenceUrl() || typeof lastMatch.callupUrl === 'function' && lastMatch.callupUrl() || typeof lastMatch.previewUrl === 'function' && lastMatch.previewUrl()) && m("div", {
      style: "display: flex; flex-direction: column; gap: 8px; background: rgba(0,0,0,0.03); padding: 12px 16px; border-radius: 10px; border: 1px solid rgba(0,0,0,0.06);"
    }, m("div", {
      style: "font-size: 0.75em; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--muted-color);"
    }, "\uD83D\uDCCC Informaci\xF3n Previa"), m("div", {
      style: "display: flex; flex-wrap: wrap; gap: 10px; align-items: center;"
    }, typeof lastMatch.tvChannel === 'function' && lastMatch.tvChannel() && m("div", {
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; background: rgba(96,165,250,0.15); color: #3b82f6; padding: 6px 14px; border-radius: 8px;"
    }, m("i", {
      className: "fas fa-tv"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.tv_label', {
      channel: lastMatch.tvChannel()
    }))), typeof lastMatch.referee === 'function' && lastMatch.referee() && m("div", {
      style: "font-size: 0.9em; font-weight: 600; background: rgba(255,255,255,0.03); padding: 6px 12px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.06);"
    }, m("i", {
      className: "fas fa-balance-scale",
      style: "margin-right: 6px; color: #f59e0b;"
    }), m("span", null, "\xC1rbitro: ", m("strong", {
      style: "color: var(--heading-color);"
    }, lastMatch.referee()))), typeof lastMatch.varReferee === 'function' && lastMatch.varReferee() && m("div", {
      style: "font-size: 0.9em; font-weight: 600; background: rgba(255,255,255,0.03); padding: 6px 12px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.06);"
    }, m("i", {
      className: "fas fa-desktop",
      style: "margin-right: 6px; color: #3b82f6;"
    }), m("span", null, "VAR: ", m("strong", {
      style: "color: var(--heading-color);"
    }, lastMatch.varReferee()))), typeof lastMatch.pressConferenceUrl === 'function' && lastMatch.pressConferenceUrl() && m("a", {
      href: lastMatch.pressConferenceUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 6px 14px; text-decoration: none;"
    }, m("i", {
      className: "fas fa-video",
      style: "color: #ec4899;"
    }), m("span", null, "Rueda de Prensa Previa")), typeof lastMatch.callupUrl === 'function' && lastMatch.callupUrl() && m("a", {
      href: lastMatch.callupUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 6px 14px; text-decoration: none;"
    }, m("i", {
      className: "fas fa-list-ol",
      style: "color: #10b981;"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.callup_button'))), typeof lastMatch.previewUrl === 'function' && lastMatch.previewUrl() && m("a", {
      href: lastMatch.previewUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 6px 14px; text-decoration: none;"
    }, m("i", {
      className: "fas fa-newspaper",
      style: "color: #f59e0b;"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.calendar.preview_button'))))), (typeof lastMatch.postPressConferenceUrl === 'function' && lastMatch.postPressConferenceUrl() || typeof lastMatch.highlightsUrl === 'function' && lastMatch.highlightsUrl() || typeof lastMatch.fullMatchUrl === 'function' && lastMatch.fullMatchUrl() || typeof lastMatch.attendance === 'function' && lastMatch.attendance()) && m("div", {
      style: "display: flex; flex-direction: column; gap: 8px; background: rgba(0,0,0,0.03); padding: 12px 16px; border-radius: 10px; border: 1px solid rgba(0,0,0,0.06);"
    }, m("div", {
      style: "font-size: 0.75em; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--muted-color);"
    }, "\uD83C\uDFAC Informaci\xF3n Posterior"), m("div", {
      style: "display: flex; flex-wrap: wrap; gap: 10px; align-items: center;"
    }, typeof lastMatch.attendance === 'function' && lastMatch.attendance() && m("div", {
      style: "font-size: 0.9em; font-weight: 600; background: rgba(255,255,255,0.03); padding: 6px 12px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.06);"
    }, m("i", {
      className: "fas fa-users",
      style: "margin-right: 6px; color: #10b981;"
    }), m("span", null, "Asistencia: ", m("strong", {
      style: "color: var(--heading-color);"
    }, new Intl.NumberFormat().format(lastMatch.attendance()), " espectadores"))), typeof lastMatch.postPressConferenceUrl === 'function' && lastMatch.postPressConferenceUrl() && m("a", {
      href: lastMatch.postPressConferenceUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 6px 14px; text-decoration: none;"
    }, m("i", {
      className: "fas fa-microphone",
      style: "color: #a855f7;"
    }), m("span", null, "Rueda de Prensa Posterior")), typeof lastMatch.highlightsUrl === 'function' && lastMatch.highlightsUrl() && m("a", {
      href: lastMatch.highlightsUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 6px 14px; text-decoration: none;"
    }, m("i", {
      className: "fas fa-play-circle",
      style: "color: #ef4444;"
    }), m("span", null, "Resumen del Partido")), typeof lastMatch.fullMatchUrl === 'function' && lastMatch.fullMatchUrl() && m("a", {
      href: lastMatch.fullMatchUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 6px 14px; text-decoration: none;"
    }, m("i", {
      className: "fas fa-film",
      style: "color: #3b82f6;"
    }), m("span", null, "Partido Completo")))), typeof lastMatch.goalEvents === 'function' && Array.isArray(lastMatch.goalEvents()) && lastMatch.goalEvents().length > 0 && m("div", {
      style: "background: rgba(255,255,255,0.02); border-radius: 10px; padding: 14px 18px; border: 1px solid rgba(255,255,255,0.05); display: flex; flex-direction: column; gap: 8px;"
    }, m("div", {
      style: "font-size: 0.85em; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--muted-color); margin-bottom: 4px;"
    }, "\u26BD Goles"), m("div", {
      style: "display: flex; flex-direction: column; gap: 6px;"
    }, lastMatch.goalEvents().map(g => {
      const pId = g.player_id || g.playerId;
      const playerObj = pId ? this.players.find(p => String(p.id()) === String(pId)) : null;
      const photo = playerObj && typeof playerObj.photoUrl === 'function' ? playerObj.photoUrl() : null;
      const isLocal = typeof lastMatch.isLocal === 'function' ? lastMatch.isLocal() : true;
      const athleticName = app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Athletic';
      const rivalObj = lastMatch.rival ? lastMatch.rival() : null;
      const opponentName = rivalObj ? rivalObj.name() : typeof lastMatch.opponent === 'function' ? lastMatch.opponent() : 'Rival';
      const athleticTeam = lastMatch.team ? lastMatch.team() : null;
      const defaultClubShield = athleticName.includes('Real Sociedad') ? '/assets/extensions/nagusi-match-ratings/escudos/real-sociedad.png' : '/assets/extensions/nagusi-match-ratings/escudos/athletic-club.png';
      const athleticShield = formatShieldUrl(athleticTeam && typeof athleticTeam.logoUrl === 'function' ? athleticTeam.logoUrl() : null) || defaultClubShield;
      const rivalShield = rivalObj && typeof rivalObj.escudo === 'function' ? formatShieldUrl(rivalObj.escudo()) : null;
      const isGoalLocal = g.team === 'local';
      const goalTeamName = isGoalLocal ? isLocal ? athleticName : opponentName : isLocal ? opponentName : athleticName;
      const goalTeamShield = isGoalLocal ? isLocal ? athleticShield : rivalShield : isLocal ? rivalShield : athleticShield;
      return m("div", {
        style: "display: flex; align-items: center; gap: 8px; font-size: 0.9em; font-weight: 600;"
      }, m("span", {
        style: "font-family: monospace; font-weight: 800; color: #ee2523; background: rgba(238,37,35,0.1); padding: 1px 6px; border-radius: 4px; font-size: 0.85em;"
      }, g.minute), m("span", {
        style: "display: inline-flex; align-items: center; gap: 4px; font-size: 0.8em; color: var(--muted-color);"
      }, "(", goalTeamShield && m("img", {
        src: goalTeamShield,
        alt: "",
        style: "width: 16px; height: 16px; object-fit: contain;"
      }), goalTeamName, ")"), photo && m("img", {
        src: photo,
        alt: "",
        style: "width: 22px; height: 22px; border-radius: 50%; object-fit: cover; border: 1px solid rgba(255,255,255,0.15);"
      }), m("span", {
        style: "color: var(--heading-color);"
      }, g.name || (playerObj ? playerObj.name() : 'Jugador'), g.is_own_goal || g.isOwnGoal ? ' (p.p.)' : ''));
    }))), typeof lastMatch.notesHtml === 'function' && lastMatch.notesHtml() && m("div", {
      style: "background: rgba(255,255,255,0.02); border-radius: 10px; padding: 16px 20px; border: 1px solid rgba(255,255,255,0.06); display: flex; flex-direction: column; gap: 10px;"
    }, m("div", {
      style: "font-size: 0.85em; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--muted-color);"
    }, "\uD83D\uDCDD ", app.translator.trans('nagusi-match-ratings.forum.calendar.notes_label')), m("div", {
      style: "font-size: 0.95em; line-height: 1.6; color: var(--text-color);"
    }, this.renderNotesHtml(lastMatch.notesHtml()))), m("div", {
      style: "border-top: 1px solid rgba(0,0,0,0.06); padding-top: 12px;"
    }, m(Button, {
      className: "Button Button--secondary",
      onclick: () => this.toggleLastRatings(lastMatch),
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 8px 16px;"
    }, this.loadingLastRatings ? m("i", {
      className: "fas fa-spinner fa-spin",
      style: "color: #ee2524;"
    }) : m("i", {
      className: "fas fa-chevron-".concat(this.expandedLastRatings ? 'up' : 'down')
    }), m("span", null, this.expandedLastRatings ? app.translator.trans('nagusi-match-ratings.forum.calendar.hide_ratings_button') : app.translator.trans('nagusi-match-ratings.forum.calendar.show_ratings_button'))), this.expandedLastRatings && m("div", {
      style: "margin-top: 16px; background: rgba(0,0,0,0.02); border-radius: 10px; padding: 18px; border: 1px solid rgba(0,0,0,0.08); display: flex; flex-direction: column; align-items: center; gap: 15px;"
    }, this.loadingLastRatings ? m("div", {
      style: "padding: 20px; text-align: center;"
    }, m(LoadingIndicator, {
      size: "small"
    })) : lastRatings.length > 0 ? m("div", {
      style: "width: 100%;"
    }, m("p", {
      style: "margin: 0 0 12px 0; font-weight: 700; color: var(--heading-color);"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.community_avg_rating')), m("div", {
      style: "display: grid; grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)); gap: 10px;"
    }, lastRatings.map(r => m("div", {
      style: "background: var(--control-bg); border-radius: 8px; padding: 8px 12px; display: flex; align-items: center; justify-content: space-between; border: 1px solid rgba(0,0,0,0.05);"
    }, m("span", {
      style: "font-weight: bold; font-size: 0.9em; color: var(--text-color);"
    }, r.name), m("span", {
      style: "font-weight: 900; font-size: 1.05em; color: #ee2523; background: rgba(238,37,35,0.08); padding: 2px 8px; border-radius: 6px; font-family: monospace;"
    }, r.average))))) : m("p", {
      style: "margin: 0; color: var(--muted-color);"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.no_ratings_yet')), typeof lastMatch.discussion === 'function' && lastMatch.discussion() && m("a", {
      href: app.route('discussion', {
        id: lastMatch.discussion().id()
      }),
      className: "Button Button--primary",
      style: "font-weight: bold; border-radius: 8px; margin-top: 6px; text-decoration: none;"
    }, m("i", {
      className: "fas fa-star",
      style: "margin-right: 8px;"
    }), app.translator.trans('nagusi-match-ratings.forum.calendar.submit_your_rating_button')))))), this.viewMode === 'calendar' ? m("div", {
      className: "CalendarPage-calendarSection"
    }, m(CalendarMonthView, {
      matches: this.matches,
      players: this.players,
      selectedSeasonName: this.selectedSeasonName,
      featuredNextMatch: nextMatch,
      featuredLastMatch: lastMatch,
      selectedMatchId: this.selectedCalendarMatchId,
      onSelectMatch: matchItem => {
        this.selectedCalendarMatchId = matchItem ? String(matchItem.id()) : null;
        m.redraw();
      },
      formatMatchDate: this.formatMatchDate.bind(this),
      isPlaceholderTime: this.isPlaceholderTime.bind(this),
      getScoreBadgeStyle: this.getScoreBadgeStyle.bind(this),
      getMatchOutcome: this.getMatchOutcome.bind(this),
      renderNotesHtml: this.renderNotesHtml.bind(this),
      onSwitchToList: matchId => {
        this.setViewMode('list');
        if (matchId) {
          this.expandedMatchIds[String(matchId)] = true;
          setTimeout(() => {
            const el = document.getElementById("partido-".concat(matchId));
            if (el) el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }, 100);
        }
      }
    })) : m("div", {
      className: "CalendarPage-restMatches",
      style: "background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.08); border-radius: 20px; padding: 26px;"
    }, m("h3", {
      style: "font-size: 1.4em; font-weight: 800; margin: 0 0 20px 0; color: var(--heading-color);"
    }, app.translator.trans('nagusi-match-ratings.forum.calendar.all_season_matches', {
      season: this.selectedSeasonName
    })), restOfMatches.length > 0 ? m("div", {
      className: "CalendarPage-grid"
    }, restOfMatches.map(matchItem => {
      const mId = String(matchItem.id());
      const isExpanded = !!this.expandedMatchIds[mId];
      const mDate = typeof matchItem.matchDate === 'function' && matchItem.matchDate() ? this.formatMatchDate(matchItem.matchDate(), 'short') : app.translator.trans('nagusi-match-ratings.forum.calendar.to_be_determined');
      const score = typeof matchItem.getScore === 'function' ? matchItem.getScore() : null;
      const matchName = typeof matchItem.renderName === 'function' ? matchItem.renderName({
        showJornada: false,
        showScore: false
      }) : typeof matchItem.getName === 'function' ? matchItem.getName() : 'Partido';
      const jornadaLabel = typeof matchItem.jornada === 'function' && matchItem.jornada() ? matchItem.jornada() : null;
      const tvChannel = typeof matchItem.tvChannel === 'function' ? matchItem.tvChannel() : null;
      const isLocal = typeof matchItem.isLocal === 'function' ? matchItem.isLocal() : true;
      const athleticName = app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Athletic';
      const rivalObj = matchItem.rival ? matchItem.rival() : null;
      const opponentName = rivalObj ? rivalObj.name() : typeof matchItem.opponent === 'function' ? matchItem.opponent() : 'Rival';
      const localTeamName = isLocal ? athleticName : opponentName;
      const visitorTeamName = isLocal ? opponentName : athleticName;
      const hasPre = typeof matchItem.previewUrl === 'function' && matchItem.previewUrl() || typeof matchItem.pressConferenceUrl === 'function' && matchItem.pressConferenceUrl() || typeof matchItem.callupUrl === 'function' && matchItem.callupUrl() || typeof matchItem.referee === 'function' && matchItem.referee() || typeof matchItem.varReferee === 'function' && matchItem.varReferee();
      const hasPost = typeof matchItem.postPressConferenceUrl === 'function' && matchItem.postPressConferenceUrl() || typeof matchItem.highlightsUrl === 'function' && matchItem.highlightsUrl() || typeof matchItem.fullMatchUrl === 'function' && matchItem.fullMatchUrl() || typeof matchItem.attendance === 'function' && matchItem.attendance();
      const hasGoals = typeof matchItem.goalEvents === 'function' && Array.isArray(matchItem.goalEvents()) && matchItem.goalEvents().length > 0;
      const hasNotes = typeof matchItem.notesHtml === 'function' && matchItem.notesHtml();
      const comp = typeof matchItem.competition === 'function' ? matchItem.competition() : null;
      const compColor = comp && typeof comp.color === 'function' && comp.color() ? comp.color() : '#ee2524';
      const compIcon = comp && typeof comp.iconUrl === 'function' ? comp.iconUrl() : null;
      const compShort = comp && typeof comp.shortName === 'function' && comp.shortName() ? comp.shortName() : comp && typeof comp.name === 'function' ? comp.name() : null;
      const compName = comp && typeof comp.name === 'function' ? comp.name() : null;
      const compSlug = comp && typeof comp.slug === 'function' ? comp.slug() : null;
      let isDuplicateJornada = false;
      if (comp && jornadaLabel) {
        const jLower = jornadaLabel.toLowerCase().trim();
        if (compShort && jLower === compShort.toLowerCase().trim() || compName && jLower === compName.toLowerCase().trim() || compSlug && (jLower === compSlug.toLowerCase().trim() || compSlug === 'euskal-herriko-kopa' && (jLower === 'eh kopa' || jLower === 'ehk'))) {
          isDuplicateJornada = true;
        }
      }
      const shouldShowJornada = !!jornadaLabel && !isDuplicateJornada;
      return m("div", {
        id: "partido-".concat(mId),
        className: "CalendarPage-matchItem ".concat(isExpanded ? 'is-expanded' : ''),
        style: {
          gridColumn: isExpanded ? '1 / -1' : 'auto'
        }
      }, m("div", {
        className: "CalendarPage-matchItem-row1"
      }, m("div", {
        className: "CalendarPage-matchItem-meta"
      }, m("a", {
        href: "#partido-".concat(mId),
        onclick: e => {
          e.preventDefault();
          history.replaceState(null, '', "#partido-".concat(mId));
          this.checkAndScrollToAnchor();
        },
        title: "Enlace directo a este partido",
        className: "CalendarPage-anchorLink"
      }, m("i", {
        className: "fas fa-hashtag"
      })), comp && m("span", {
        className: "CalendarPage-compBadge",
        style: "background: ".concat(compColor, "18; color: ").concat(compColor, "; border-color: ").concat(compColor, "38;")
      }, compIcon && m("img", {
        src: compIcon,
        alt: "",
        className: "CalendarPage-compBadge-icon"
      }), m("span", null, compShort)), shouldShowJornada && m("span", {
        className: "CalendarPage-jornadaBadge"
      }, jornadaLabel), m("span", {
        className: "CalendarPage-dateLabel"
      }, m("i", {
        className: this.isPlaceholderTime(matchItem.matchDate()) ? "far fa-calendar-alt" : "far fa-clock"
      }), m("span", null, mDate))), m("div", {
        className: "CalendarPage-matchItem-actions"
      }, tvChannel && m("span", {
        className: "CalendarPage-tvBadge"
      }, m("i", {
        className: "fas fa-tv"
      }), m("span", null, tvChannel)), m(Button, {
        className: "Button Button--link CalendarPage-expandButton",
        onclick: () => this.toggleMatchExpand(matchItem)
      }, m("i", {
        className: "fas fa-chevron-".concat(isExpanded ? 'up' : 'down')
      }), m("span", null, isExpanded ? 'Menos info' : 'Más info')))), m("div", {
        className: "CalendarPage-matchItem-row2",
        style: "display: flex; align-items: center; justify-content: space-between; gap: 10px; font-weight: 700; font-size: 1.05em; width: 100%;"
      }, m("div", {
        style: "display: flex; align-items: center; gap: 8px; flex-wrap: wrap;"
      }, matchName), score && m("span", {
        style: _objectSpread({
          fontWeight: 900,
          padding: '4px 12px',
          borderRadius: '6px',
          fontFamily: 'monospace',
          fontSize: '1.05em',
          whiteSpace: 'nowrap'
        }, this.getScoreBadgeStyle(matchItem))
      }, score)), isExpanded && m("div", {
        style: "border-top: 1px solid rgba(255,255,255,0.08); padding-top: 14px; margin-top: 4px; display: flex; flex-direction: column; gap: 14px; animation: fadeIn 0.2s ease-in-out;"
      }, !hasPre && !hasPost && !hasGoals && !hasNotes && m("div", {
        style: "font-size: 0.85em; color: var(--muted-color); font-style: italic; padding: 4px 0;"
      }, "No hay informaci\xF3n adicional disponible para este partido."), hasPre && m("div", {
        style: "display: flex; flex-direction: column; gap: 6px;"
      }, m("div", {
        style: "font-size: 0.75em; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--muted-color);"
      }, "\uD83D\uDCCC Informaci\xF3n Previa"), m("div", {
        style: "display: flex; flex-wrap: wrap; gap: 10px; align-items: center;"
      }, tvChannel && m("div", {
        style: "display: inline-flex; align-items: center; gap: 6px; font-weight: bold; background: rgba(96,165,250,0.15); color: #3b82f6; padding: 4px 10px; border-radius: 6px; font-size: 0.85em;"
      }, m("i", {
        className: "fas fa-tv"
      }), m("span", null, tvChannel)), typeof matchItem.referee === 'function' && matchItem.referee() && m("div", {
        style: "font-size: 0.85em; font-weight: 600; background: rgba(255,255,255,0.03); padding: 4px 10px; border-radius: 6px;"
      }, m("i", {
        className: "fas fa-balance-scale",
        style: "margin-right: 4px; color: #f59e0b;"
      }), " \xC1rbitro: ", m("strong", {
        style: "color: var(--heading-color);"
      }, matchItem.referee())), typeof matchItem.varReferee === 'function' && matchItem.varReferee() && m("div", {
        style: "font-size: 0.85em; font-weight: 600; background: rgba(255,255,255,0.03); padding: 4px 10px; border-radius: 6px;"
      }, m("i", {
        className: "fas fa-desktop",
        style: "margin-right: 4px; color: #3b82f6;"
      }), " VAR: ", m("strong", {
        style: "color: var(--heading-color);"
      }, matchItem.varReferee())), typeof matchItem.pressConferenceUrl === 'function' && matchItem.pressConferenceUrl() && m("a", {
        href: matchItem.pressConferenceUrl(),
        target: "_blank",
        rel: "noopener noreferrer",
        className: "Button Button--secondary",
        style: "font-size: 0.85em; font-weight: bold; border-radius: 8px; padding: 4px 12px; text-decoration: none;"
      }, m("i", {
        className: "fas fa-video",
        style: "color: #ec4899; margin-right: 6px;"
      }), " Rueda de Prensa Previa"), typeof matchItem.callupUrl === 'function' && matchItem.callupUrl() && m("a", {
        href: matchItem.callupUrl(),
        target: "_blank",
        rel: "noopener noreferrer",
        className: "Button Button--secondary",
        style: "font-size: 0.85em; font-weight: bold; border-radius: 8px; padding: 4px 12px; text-decoration: none;"
      }, m("i", {
        className: "fas fa-list-ol",
        style: "color: #10b981; margin-right: 6px;"
      }), " Convocatoria"), typeof matchItem.previewUrl === 'function' && matchItem.previewUrl() && m("a", {
        href: matchItem.previewUrl(),
        target: "_blank",
        rel: "noopener noreferrer",
        className: "Button Button--secondary",
        style: "font-size: 0.85em; font-weight: bold; border-radius: 8px; padding: 4px 12px; text-decoration: none;"
      }, m("i", {
        className: "fas fa-newspaper",
        style: "color: #f59e0b; margin-right: 6px;"
      }), " Previa del Partido"))), hasPost && m("div", {
        style: "display: flex; flex-direction: column; gap: 6px;"
      }, m("div", {
        style: "font-size: 0.75em; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--muted-color);"
      }, "\uD83C\uDFAC Informaci\xF3n Posterior"), m("div", {
        style: "display: flex; flex-wrap: wrap; gap: 10px; align-items: center;"
      }, typeof matchItem.attendance === 'function' && matchItem.attendance() && m("div", {
        style: "font-size: 0.85em; font-weight: 600; background: rgba(255,255,255,0.03); padding: 4px 10px; border-radius: 6px;"
      }, m("i", {
        className: "fas fa-users",
        style: "margin-right: 4px; color: #10b981;"
      }), " Asistencia: ", m("strong", {
        style: "color: var(--heading-color);"
      }, new Intl.NumberFormat().format(matchItem.attendance()))), typeof matchItem.postPressConferenceUrl === 'function' && matchItem.postPressConferenceUrl() && m("a", {
        href: matchItem.postPressConferenceUrl(),
        target: "_blank",
        rel: "noopener noreferrer",
        className: "Button Button--secondary",
        style: "font-size: 0.85em; font-weight: bold; border-radius: 8px; padding: 4px 12px; text-decoration: none;"
      }, m("i", {
        className: "fas fa-microphone",
        style: "color: #a855f7; margin-right: 6px;"
      }), " Rueda de Prensa Posterior"), typeof matchItem.highlightsUrl === 'function' && matchItem.highlightsUrl() && m("a", {
        href: matchItem.highlightsUrl(),
        target: "_blank",
        rel: "noopener noreferrer",
        className: "Button Button--secondary",
        style: "font-size: 0.85em; font-weight: bold; border-radius: 8px; padding: 4px 12px; text-decoration: none;"
      }, m("i", {
        className: "fas fa-play-circle",
        style: "color: #ef4444; margin-right: 6px;"
      }), " Resumen"), typeof matchItem.fullMatchUrl === 'function' && matchItem.fullMatchUrl() && m("a", {
        href: matchItem.fullMatchUrl(),
        target: "_blank",
        rel: "noopener noreferrer",
        className: "Button Button--secondary",
        style: "font-size: 0.85em; font-weight: bold; border-radius: 8px; padding: 4px 12px; text-decoration: none;"
      }, m("i", {
        className: "fas fa-film",
        style: "color: #3b82f6; margin-right: 6px;"
      }), " Partido Completo"))), hasGoals && m("div", {
        style: "display: flex; flex-direction: column; gap: 6px;"
      }, m("div", {
        style: "font-size: 0.75em; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--muted-color);"
      }, "\u26BD Goles"), m("div", {
        style: "display: flex; flex-wrap: wrap; gap: 8px;"
      }, matchItem.goalEvents().map(g => {
        const pId = g.player_id || g.playerId;
        const playerObj = pId ? this.players.find(p => String(p.id()) === String(pId)) : null;
        const photo = playerObj && typeof playerObj.photoUrl === 'function' ? playerObj.photoUrl() : null;
        const athleticTeam = matchItem.team ? matchItem.team() : null;
        const defaultClubShield = athleticName.includes('Real Sociedad') ? '/assets/extensions/nagusi-match-ratings/escudos/real-sociedad.png' : '/assets/extensions/nagusi-match-ratings/escudos/athletic-club.png';
        const athleticShield = formatShieldUrl(athleticTeam && typeof athleticTeam.logoUrl === 'function' ? athleticTeam.logoUrl() : null) || defaultClubShield;
        const rivalShield = rivalObj && typeof rivalObj.escudo === 'function' ? formatShieldUrl(rivalObj.escudo()) : null;
        const isGoalLocal = g.team === 'local';
        const goalTeamName = isGoalLocal ? localTeamName : visitorTeamName;
        const goalTeamShield = isGoalLocal ? isLocal ? athleticShield : rivalShield : isLocal ? rivalShield : athleticShield;
        return m("div", {
          style: "background: rgba(255,255,255,0.04); border-radius: 6px; padding: 4px 8px; display: flex; align-items: center; gap: 6px; font-size: 0.85em;"
        }, m("span", {
          style: "font-family: monospace; font-weight: bold; color: #ee2523;"
        }, g.minute), m("span", {
          style: "display: inline-flex; align-items: center; gap: 4px; font-size: 0.8em; color: var(--muted-color);"
        }, "(", goalTeamShield && m("img", {
          src: goalTeamShield,
          alt: "",
          style: "width: 14px; height: 14px; object-fit: contain;"
        }), goalTeamName, ")"), photo && m("img", {
          src: photo,
          alt: "",
          style: "width: 18px; height: 18px; border-radius: 50%; object-fit: cover;"
        }), m("span", null, g.name || (playerObj ? playerObj.name() : 'Jugador'), g.is_own_goal || g.isOwnGoal ? ' (p.p.)' : ''));
      }))), hasNotes && m("div", {
        style: "display: flex; flex-direction: column; gap: 6px;"
      }, m("div", {
        style: "font-size: 0.75em; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: var(--muted-color);"
      }, "\uD83D\uDCDD ", app.translator.trans('nagusi-match-ratings.forum.calendar.notes_label')), m("div", {
        style: "font-size: 0.9em; line-height: 1.5; color: var(--text-color); white-space: pre-wrap;"
      }, this.renderNotesHtml(matchItem.notesHtml())))));
    })) : m("p", {
      style: "color: var(--muted-color); margin: 0;"
    }, "No hay otros partidos en el listado para esta temporada."))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/calendar/CalendarPage', CalendarPage);